import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EventBusService } from 'src/app/services/common/event.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  items: MenuItem[] = [];
  itemsRight : MenuItem[] = [];
  constructor(public auth: AuthService,
    private eventBus: EventBusService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.updateMenu();
    this.eventBus.on('LOGIN', () => this.updateMenu());
    this.eventBus.on('LOGOUT', () => this.updateMenu());
  }

  onLogout(item : MenuItem) {
    this._router.navigate([item.routerLink]);
  }
  private updateMenu(): void {
    this.items = [];
    this.itemsRight = [];
    const currentUser = this.auth.currentUser;
    this.items.push({
      label: "МАКМАХ",
      routerLink : '/',
      // icon: 'pi pi-home'
    });
    if (currentUser) {
      this.items.push({ label: 'Люди', routerLink: '/people' });
      this.items.push({ label: 'Регистрация', routerLink: '/registration' });
      this.items.push({ label: 'Тезисы', routerLink: '/abstract' });

      if (this.auth.isAdminUser()) {
        this.items.push({ label: 'Конференции', routerLink: '/conferences' });
        this.items.push({ label: 'Статистика', routerLink: '/stat' });
        this.items.push({





          label: 'Справочники',
          items: [
            { label: 'Компании', routerLink: '/dictionaries/companies' },
            this.auth.isAdminUser() ? { label: 'Типы оплаты', routerLink: '/dictionaries/paymenttypes' } : null,
            this.auth.isRootUser() ? { label: 'Статусы тезисов', routerLink: '/dictionaries/abstract-statuses' } : null,
            this.auth.isRootUser() ? { label: 'Формы участия', routerLink: '/dictionaries/ranks' } : null,
            this.auth.isRootUser() ? { label: 'Степени', routerLink: '/dictionaries/science-degrees' } : null,
            this.auth.isRootUser() ? { label: 'Звания', routerLink: '/dictionaries/science-statuses' } : null,
            this.auth.isRootUser() ? { label: 'Специальности', routerLink: '/dictionaries/specialities' } : null,
            this.auth.isRootUser() ? { label: 'Кодировка', routerLink: '/dictionaries/codings' } : null,
            this.auth.isRootUser() ? { label: 'География', routerLink: '/geo' } : null,
            this.auth.isRootUser() ? { label: 'Геозамены', routerLink: '/geo-replacements' } : null,
            this.auth.isRootUser() ? { label: 'Рассылка отписка', routerLink: '/dictionaries/blacklist' } : null,
            this.auth.isRootUser() ? { label: 'Рассылка подписка', routerLink: '/dictionaries/subscriptions' } : null,
            this.auth.isRootUser() ? { label: 'Удаление email', routerLink: '/dictionaries/email-cleaner' } : null,
            this.auth.isRootUser() ? { label: 'Отправки email', routerLink: '/email-messages' } : null,
            this.auth.isRootUser() ? { label: 'Пользователи', routerLink: '/users' } : null,

          ].filter(item => item) as MenuItem[]
        });
      }
      this.itemsRight.push({
        label: `Выйти (${currentUser.name})`,
        routerLink: '/auth/logout',
        // icon: 'pi pi-sign-out',
      });
    }
  }
}
